import type { CourseTypesLabels } from '@/models/catalog/course';
import type { ResourceTypes } from '@/models/resources';

export enum EligibleResourceType {
  ThreeSixty = '360',
  Catalog = 'catalog',
}

interface Limits {
  amount_available: string | null;
  amount_limit_per_cycle_cents: string | null;
  amount_limit_per_purchase_cents: string | null;
  percentage_limit_per_purchase: string | null;
}

interface Configuration {
  allow_refund_request_amount_override: boolean;
  auto_approval_enabled: boolean;
  course_eligibility_kind: string;
  eligible_resource_type: EligibleResourceType;
  eligible_user_type: string;
  refund_eligibility_in_days: number;
  eligible_course_types: CourseTypesLabels[];
  eligible_external_resource_kinds: ResourceTypes[];
}

interface RequestLimitInfo {
  max_refunds_per_period: number;
  renewal_period_in_months: number;
  can_make_request: boolean;
}

export interface Policy {
  uuid: string;
  name: string;
  description: string;
  cycle_size_in_months: number;
  limits: Limits;
  configuration: Configuration;
  request_limit_info: RequestLimitInfo;
  ends_cycle_at: string;
}
